import React from "react";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Inventory from "./pages/Inventory";
import UserManagement from "./pages/UserManagement";
import Setting from "./pages/Setting";
import NoPageFound from "./pages/NoPageFound";
import AuthContext from "./AuthContext";
import ProtectedWrapper from "./ProtectedWrapper";
import PermissionWrapper from "./PermissionWrapper";
import { PermissionProvider } from "./contexts/PermissionContext";
import { useEffect, useState } from "react";
import Store from "./pages/Store";
import Sales from "./pages/ExpenseList";
import PurchaseList from "./pages/PurchaseList";
// import GenerateReport from "./pages/GenerateReport";
import ProductReport from "./pages/ProductReport";
import StockReport from "./pages/StockReport";
import ExpenseReport from "./pages/ExpenseReport";
import PurchaseReport from "./pages/PurchaseReport";
import PermissionTest from "./pages/PermissionTest";
import BarcodeGenerator from "./pages/BarcodeGenerator";
import ProductTracking from "./pages/ProductTracking";
import EquipmentRequests from "./pages/EquipmentRequests";
import ServiceRequests from "./pages/ServiceRequests";
import Branch from "./pages/Branch";
import { Toaster } from "react-hot-toast";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // disable automatic refetching on window focus
      retry: 1, // retry failed requests only once
      staleTime: 5 * 60 * 1000, // data is considered fresh for 5 minutes
    },
  },
});

const App = () => {
  const [user, setUser] = useState("");
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const initializeAuth = () => {
      const myLoginUser = localStorage.getItem("user");
      const token = localStorage.getItem("token");

      if (myLoginUser && token) {
        const userData = JSON.parse(myLoginUser);
        setUser(userData._id);
      }
      setLoader(false);
    };

    initializeAuth();
  }, []);

  const signin = (newUser, callback) => {
    setUser(newUser);
    if (callback) callback();
  };

  const signout = () => {
    setUser("");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  let value = { user, signin, signout };

  if (loader)
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <h1>LOADING...</h1>
      </div>
    );

  return (
    <QueryClientProvider client={queryClient}>
      <Toaster position="top-right" />
      <AuthContext.Provider value={value}>
        <PermissionProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/"
                element={
                  <ProtectedWrapper>
                    <Layout />
                  </ProtectedWrapper>
                }
              >
                <Route index element={<Dashboard />} />
                <Route
                  path="/products"
                  element={
                    <PermissionWrapper requiredModule="products">
                      <Inventory />
                    </PermissionWrapper>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <PermissionWrapper requiredModule="users">
                      <UserManagement />
                    </PermissionWrapper>
                  }
                />
                <Route
                  path="/purchase"
                  element={
                    <PermissionWrapper requiredModule="purchase">
                      <PurchaseList />
                    </PermissionWrapper>
                  }
                />
                <Route
                  path="/expense"
                  element={
                    <PermissionWrapper requiredModule="expense">
                      <Sales />
                    </PermissionWrapper>
                  }
                />
                <Route
                  path="/supplyer"
                  element={
                    <PermissionWrapper requiredModule="supplier">
                      <Store />
                    </PermissionWrapper>
                  }
                />
                <Route
                  path="/branch"
                  element={
                    <PermissionWrapper requiredModule="branch">
                      <Branch />
                    </PermissionWrapper>
                  }
                />
                {/* <Route
                  path="/reports"
                  element={
                    // <PermissionWrapper requiredModule="reports">
                    <GenerateReport />
                    // </PermissionWrapper>
                  }
                /> */}
                <Route
                  path="/reports/product"
                  element={
                    <PermissionWrapper requiredModule="products-report">
                    <ProductReport />
                    </PermissionWrapper>
                  }
                />

                    <Route
                  path="/reports/stock"
                  element={
                    <PermissionWrapper requiredModule="products-report">
                    <StockReport />
                    </PermissionWrapper>
                  }
                />

                <Route
                  path="/reports/expense"
                  element={
                    <PermissionWrapper requiredModule="expense-report">
                    <ExpenseReport />
                     </PermissionWrapper>
                  }
                />

                
                        <Route
                  path="/reports/purchase"
                  element={
                    <PermissionWrapper requiredModule="purchase-report">
                    <PurchaseReport />
                     </PermissionWrapper>
                  }
                />
                
                

                  <Route
                  path="/setting"
                  element={
                    <PermissionWrapper requiredModule="users">
                      <Setting />
                    </PermissionWrapper>
                  }
                />
                

                <Route path="/tracking" element={<ProductTracking />} />
                <Route
                  path="/equipment-requests"
                  element={
                    <PermissionWrapper requiredModule="equipment-request">
                      <EquipmentRequests />
                    </PermissionWrapper>
                  }
                />
                <Route
                  path="/service-requests"
                  element={
                    <PermissionWrapper requiredModule="service-request">
                      <ServiceRequests />
                    </PermissionWrapper>
                  }
                />
                <Route path="/barcode" element={<BarcodeGenerator />} />
                <Route path="/permission-test" element={<PermissionTest />} />
                <Route path="/profile" element={<Profile />} />
              </Route>
              <Route path="*" element={<NoPageFound />} />
            </Routes>
          </BrowserRouter>
        </PermissionProvider>
      </AuthContext.Provider>
    </QueryClientProvider>
  );
};

export default App;
